(() => {
  if (window.IGSearchInitialized) return;
  window.IGSearchInitialized = true;
  const forms = document.querySelectorAll("[data-ig-search-form]");

  function element(name, className, text) {
    const node = document.createElement(name);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function money(price) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: price.currencyCode,
      }).format(Number(price.amount));
    } catch {
      return `${price.amount} ${price.currencyCode}`;
    }
  }

  function render(data, target) {
    target.replaceChildren();
    const heading = element("h2", "ig-search-results__title", `Results for ${data.query}`);
    target.append(heading);

    const routes = element("div", "ig-search-results__pages");
    for (const page of data.pages || []) {
      if (typeof page.url !== "string" || !page.url.startsWith("/")) continue;
      const link = element("a", "ig-search-page", page.title);
      link.href = page.url;
      routes.append(link);
    }
    if (routes.childElementCount) target.append(routes);

    const grid = element("div", "ig-search-results__grid");
    for (const product of data.products || []) {
      const card = element("article", "ig-search-product");
      const link = element("a", "ig-search-product__link");
      link.href = `/products/${encodeURIComponent(product.handle)}`;
      if (product.featuredImage?.url) {
        const image = document.createElement("img");
        image.src = product.featuredImage.url;
        image.alt = product.featuredImage.altText || product.title;
        image.loading = "lazy";
        image.width = product.featuredImage.width || 600;
        image.height = product.featuredImage.height || 600;
        link.append(image);
      }
      link.append(element("h3", "ig-search-product__title", product.title));
      link.append(element("p", "ig-search-product__price", money(product.price)));
      if (!product.availableForSale)
        link.append(element("p", "ig-search-product__status", "Sold out"));
      card.append(link);
      grid.append(card);
    }
    if (grid.childElementCount) target.append(grid);
    if (!routes.childElementCount && !grid.childElementCount)
      target.append(element("p", "ig-search-results__empty", "No matches found"));
  }

  async function submit(form) {
    const target = form.parentElement.querySelector("[data-ig-search-results]");
    if (!target) return;
    const query = new FormData(form).get("q")?.toString().trim();
    if (!query) return;
    target.setAttribute("aria-busy", "true");
    target.replaceChildren(element("p", "ig-search-results__status", "Searching"));
    try {
      const url = new URL(form.action, window.location.origin);
      url.searchParams.set("q", query);
      const response = await fetch(url, { headers: { Accept: "application/json" } });
      if (!response.ok) throw new Error("Search failed");
      render(await response.json(), target);
    } catch {
      target.replaceChildren(element("p", "ig-search-results__status", "Search is unavailable right now"));
    } finally {
      target.removeAttribute("aria-busy");
    }
  }

  for (const form of forms) {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      void submit(form);
    });
    if (new FormData(form).get("q")?.toString().trim()) void submit(form);
  }
})();
